import { render, staticRenderFns } from "./DetailOrderComponent.vue?vue&type=template&id=5524bbb3"
import script from "./DetailOrderComponent.vue?vue&type=script&lang=js"
export * from "./DetailOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports